package com.neurobs.ccabserver.translation.components.translationreplacement.components

import com.neurobs.ccabserver.translation.states.TranslationSubSearchStateGenerator
import com.neurobs.react.semanticui.UiButtonFactory._
import org.scalajs.dom.window
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object TranslationSave {
  case class Props()
  val component = FunctionalComponent[Props] { props =>

    val translationSubSearchState = TranslationSubSearchStateGenerator.accessState
    def update = () => translationSubSearchState.updateAllTranslations()

    def isLoading = translationSubSearchState.updateProgressState.value match {
      case None => false
      case Some(progress) => !progress.isComplete
    }

    if (isLoading) LoadingButton("green")
    else Button("Save translations", update)("green")
  }

}
